export const loggedUser = {
  company: 'University of Southern California',
  siebelRowId: '2-5WCD6R',

  // data from user-details
  userContactInfo: {
    firstName: 'Keynote',
    lastName: 'Keynote',
    // userName: 'KEYNOTE49',
    // userId: 765983,
    userId: 815135,
    userName: 'TEST003',
    contactInfo: {
      country: {
        isoCode: 'us'
      }
    }
  },

  userRoles: {
    scms: false
  },

  currencyCode: 'USD',
  customerName: 'Keynote',
  displayIso: 'us',
  displayLang: 'en',
  displayType: 'b2ccmgt',
  emailAddress: 'ITQASupport@thermofisher.com',
  isCSR: false,
  partnerLogo: '',
  shipToNumber: '277488',
  unreadMessagesCount: '0',

  // data from /user-type endpoint
  isAnonymous: false,
  isB2BMasterUser: false,
  isCrmManager: false,
  isSosManager: false,
  userType: 'b2c'
};

export const cartRequestMockHeaders = {
  countryCode: 'us',
  'request-env': 'qa1',
  languageCode: 'en',
  currencyCode: 'USD',
  cartId: 25008489,
};

export const mockAddToCartApiPayload = {
  researcherName: 'John Doe',
  oligoName: 'SAMPLEPRIMER1',
  rnaType: 'siRNA',
  senseSequence: 'ACGUACGUACGUACGUACGUACGU',
  rnaSense5Modification: 'PHO',
  rnaSynthesisScale: 'N_20',
  rnaPurification: 'DESALTED'
};
